import Swiper from 'swiper/swiper-bundle.min.mjs'

document.addEventListener('DOMContentLoaded', function () {
  const heroswiper = document.querySelectorAll('#myHeroSlider')

  if (heroswiper.length) {
    function videoInSwiper (swiper, video) {
      let waitForDuration = setInterval(function () {
        if (!isNaN(video.duration) && !video.classList.contains('pause')) {
          console.log(video.classList)
          video.volume = 0
          video.currentTime = 0
          video.play()
          let newAutoplayTime = video.duration * 1000
          swiper.params.autoplay.delay = newAutoplayTime
          clearInterval(waitForDuration)
        }
      }, 50)
    }

    let regularAutoplayTime = 5000
    let AutoplayTimeIsKnown = 0
    let autoplayTime
    if (
      document.querySelectorAll('#myHeroSlider .swiper-slide > video').length
    ) {
      let video = document.querySelector('#myHeroSlider .swiper-slide > video')
      let waitForDuration = setInterval(function () {
        if (!isNaN(video.duration)) {
          autoplayTime = video.duration * 1000
          AutoplayTimeIsKnown = 1
          clearInterval(waitForDuration)
        }
      }, 50)
    } else {
      autoplayTime = regularAutoplayTime
      AutoplayTimeIsKnown = 1
      console.log('video loaded')
    }

    let initHeroSwiper = setInterval(function () {
      if (AutoplayTimeIsKnown == 1) {
        var mySwiper = new Swiper('.mySwiper', {
          // Optional parameters
          direction: 'horizontal',
          loop: true,
          speed: 1200,
          grabCursor: false,
          mousewheel: false,
          // Autoplay aus
          // autoplay: {
          //   delay: autoplayTime
          // },
          pauseOnMouseEnter: false,
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },

          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })

        mySwiper.on('slideChange', function () {
          var swiper = this
          // console.log('change slide');
          if (
            document
              .querySelector('#myHeroSlider .swiper-slide-next')
              .querySelectorAll('video').length
          ) {
            videoInSwiper(
              swiper,
              document
                .querySelector('#myHeroSlider .swiper-slide-next')
                .querySelector('video')
            )
          } else {
            swiper.params.autoplay.delay = regularAutoplayTime
          }
        })

        if (
          document
            .querySelector('#myHeroSlider .swiper-slide-active')
            .querySelectorAll('video').length
        ) {
          videoInSwiper(
            mySwiper,
            document
              .querySelector('#myHeroSlider .swiper-slide-active')
              .querySelector('video')
          )
        } else {
          mySwiper.params.autoplay.delay = regularAutoplayTime
        }

        clearInterval(initHeroSwiper)
      }
    }, 100)

    const viewportWidth = window.innerWidth
    const element = document.querySelector('.carousel-caption')

    if (element && viewportWidth > 1199) {
      const observer = new IntersectionObserver(entries => {
        element.classList.toggle('slide-in-left', entries[0].isIntersecting)
      })
      observer.observe(element)
    }
  }
})

// Swiper mit Play/Pause Button

document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.play-pause-btn')
  const videos = document.querySelectorAll('.swiper-video')


  function addPlayPauseFunctionality (button, video) {

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        button.classList.add('play');
        button.classList.remove('pause');
        video.classList.add('play');
        video.classList.remove('pause');
      } else {
        video.pause()
        button.classList.add('pause');
        button.classList.remove('play');
        video.classList.add('pause');
        video.classList.remove('play');
      }
    })

    video.addEventListener('ended', videoEnded);
    function videoEnded() {
      // console.log('video ended');
      button.classList.add('pause');
      button.classList.remove('play');
      video.classList.add('pause');
      video.classList.remove('play');
    }
  }

  buttons.forEach((button, index) => {
    addPlayPauseFunctionality(button, videos[index])
  })


})

// Hero-Swiper Play-Botton Position

function updateButtonPosition () {
  const viewportWidth = window.innerWidth;
  var swiperCaptions = document.querySelectorAll('.swiper-caption');
  var btnPositions = document.querySelectorAll('.play-pause-btn');

  if (swiperCaptions && btnPositions) {
    swiperCaptions.forEach((swiperCaption, index) => {
      var btnPosition = btnPositions[index];

      if (btnPosition) {
        if (viewportWidth < 991) {
          var captionHeight = swiperCaption.clientHeight;
          captionHeight += 20
          btnPosition.style.bottom = captionHeight + 'px';
        } 
        else {
          btnPosition.style.bottom = 50 + 'px';
        }
      }
    })
  }
}

window.addEventListener('load', updateButtonPosition);

window.addEventListener('resize', updateButtonPosition);

// wasteSwiper - Entsorgungsplaner
import Swiper from 'swiper/swiper-bundle.min.mjs'

var swiper1 = new Swiper('.wasteSwiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  loop: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 20
    },
    991: {
      slidesPerView: 3.5,
      spaceBetween: 40
    },
    1199: {
      slidesPerView: 3.5,
      spaceBetween: 40
    },
    1599: {
      slidesPerView: 5,
      spaceBetween: 50
    }
  },
  watchSlidesProgress: true
})

var swiper2 = new Swiper('.wasteSwiper2', {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  thumbs: {
    swiper: swiper1
  }
})
